import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import ReceptionHeader from "~/components/ReceptionHeader";
import ReceptionQrScanScreen from "~/components/ReceptionQrScanScreen";
import { runReceptionBack } from "~/utils/receptionNavigation";

/**
 * 受付QR読み取りページ。
 * QR読み取り画面とサイドバーを表示し、ブラウザの戻る操作や
 * ハッシュ遷移時には受付フロー状態をリセットするためページを再読み込みする。
 */
const ReceptionQrScanPage: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleBack = useCallback(() => {
    runReceptionBack({ kind: "router-history", navigate });
  }, [navigate]);

  return (
    <div className="reception-qr-scan-page">
      <ReceptionHeader showBackButton={true} onBackButtonClick={handleBack} />
      <ReceptionQrScanScreen />
      <p className="reception_qr-trademark-note">{t("receptionQrTrademark")}</p>
    </div>
  );
};

export default ReceptionQrScanPage;
